import { ScrollableMobileContainer } from './ScrollableContainer.mobile';

export default ScrollableMobileContainer;
